import { mlflowApiClient } from '@/shared/api/core/axios-instance';

export const downloadModelArtifact = async (modelId: string, artifactPath: string): Promise<Blob> => {
  const response = await mlflowApiClient.get(`/ajax-api/2.0/mlflow/logged-models/${modelId}/artifacts/files`, {
    params: {
      artifact_file_path: artifactPath,
    },
    responseType: 'blob',
  });

  return response.data;
};
